import { string, object, number } from "yup";

const PersonalInfoValidation = object().shape({
  name: string(),
  email: string(),
  // ageId: number().required("Required"),
  specAge: number().required("Required"),
  clientTypeId: number(),
  sex: string().required("Required"),
  officeId: number().required("Required"),
  serviceKindId: number().required("Required"),
  serviceId: string().required("Required"),
});

export default PersonalInfoValidation;
